module.exports = __webpack_public_path__ + "static/media/dashboard.27b4213a.svg";